// extracted by mini-css-extract-plugin
export default {"alert":"UserNotifications_alert__sNdbz","pulse":"UserNotifications_pulse__sA7kG"};